import { render, staticRenderFns } from "./EditSubAccount.vue?vue&type=template&id=1fe435c5&"
import script from "./EditSubAccount.vue?vue&type=script&lang=ts&"
export * from "./EditSubAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports